"use strict";
require.context("../../images", true);
$(function() {
  window._jipt = [];
  window._jipt.push(["project", "decidim-octree"]);
});
